import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { ISensitiveCities } from 'src/models/sensitive-cities.model';
import { useSensitiveCitiesContext } from 'src/contexts/sensitive-cities.context';
import { actionTypes } from 'src/ducks/sensitive-cities.duck';
import { getSensitiveCitiesStatus } from 'src/selectors/sensitive-cities.selector';
import style from '../sensitive-cities-list/sensitive-cities-list.module.scss';

type IProp = {
  data: ISensitiveCities;
};

const SensitiveCityDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useSensitiveCitiesContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getSensitiveCitiesStatus(
    state,
    actionTypes.SENSITIVE_CITIES_DELETE
  );

  const handleDelete = useCallback(async () => {
    if (data.sensitiveCityId) {
      const response = await actions.itemDELETE(data.sensitiveCityId);

      if (!response.error) {
        setIsDeleteOpen(false);
        actions.listGET();

        ToastSuccess(
          Lang.formatString(
            Lang.MSG_SENSITIVE_CITY_DELETE_SUCCESS,
            data.sensitiveCity
          )
        );
      } else {
        ToastError(response.error.message);
      }
    }
  }, [actions, data]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_DELETE_SENSITIVE_CITIES}
      content={
        <div className={style.content}>
          {Lang.formatString(Lang.MSG_CONFIRM_DELETE, data.sensitiveCity)}
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default SensitiveCityDelete;
